import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ChevronsLeft = createReactComponent("ChevronsLeft", ["svg", defaultAttributes, [["polyline", {
  points: "11 17 6 12 11 7",
  key: "1yp1jo"
}], ["polyline", {
  points: "18 17 13 12 18 7",
  key: "1mbq08"
}]]]);
export default ChevronsLeft;